module.exports = __webpack_public_path__ + "spine/chicken.json?9ffe4b140f50696ca67146e692403f70";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spine/chicken/chicken.json
// module id = 1738
// module chunks = 3